export { AuthService } from './lib/services/auth.service';
import * as AuthActions from './lib/+state/auth.actions';

import * as AuthFeature from './lib/+state/auth.reducer';

import * as AuthSelectors from './lib/+state/auth.selectors';

export * from './lib/+state/auth.facade';

export { AuthActions, AuthFeature, AuthSelectors };
export * from './lib/shared-data-access-auth.module';
export const metaReducers = AuthFeature.metaReducers;

export * from './lib/auth-config';
export * from './lib/services/auth.interceptor';

export * from './lib/guards/auth.guard';
export * from './lib/guards/role.guard';
